module.exports = __webpack_public_path__ + "img/tiktok-logo.c337eca6.png";